import { createContext, useContext } from 'react';

/**
 * Context per aprire la scheda di un'entità (persona/azienda/lead/cliente) in un
 * drawer IN-PLACE, senza cambiare pagina. Fornito dalla Rubrica (ContactsPage),
 * che monta UnifiedDetailsPage in overlay: i componenti annidati (es.
 * ContactCompanyLinksSection) possono ri-targettare lo stesso drawer.
 *
 * Se il provider è assente (pagine Lead/Clienti), `openEntity` è undefined e i
 * consumer usano il fallback di navigazione classico.
 */
interface EntityDrawerContextValue {
  openEntity?: (entityId: string) => void;
}

export const EntityDrawerContext = createContext<EntityDrawerContextValue>({});

export function useEntityDrawer(): EntityDrawerContextValue {
  return useContext(EntityDrawerContext);
}
